import BaseClient from './_partials/baseClient'
import settings from "@core/vuejs/services/settings.service";

class Client extends BaseClient
{
  settings() {
    if ('undefined' !== typeof window) {
      settings.api.url = settings.api.url.replace(/^https:|http:?/, window.location.protocol);
    }
    return settings;
  }
}

export default new Client()